import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { capitalize } from 'lodash/string';
import moment from 'moment';
import AppIcon from '../../components/AppIcon';


const TimeSlotCard = ({ active, disabled, large, timeSlot, unit, onClick, actionElement }) => {
  const duration = Object.prototype.hasOwnProperty.call(timeSlot.duration, timeSlot.type) ? timeSlot.duration[timeSlot.type] : timeSlot.duration;
  return (
    <Button
      className={`time-slot-card ${large ? 'time-slot-card-large' : 'time-slot-card-small'}`}
      active={active}
      disabled={disabled}
      onClick={() => { onClick(timeSlot) }}
      block
      bsStyle="default"
      bsSize="large"
      key={`${timeSlot.reservation}-TimeSlotCard-Button`}
    >
      <span className="time-slot-card-flex">
        <span className="time-slot-card-left">
          <span className="time-slot-date">
            {capitalize(timeSlot.timeMoment.format('dd D.M.'))} {''}
            Klo {timeSlot.timeMoment.format('H.mm')}–
            {timeSlot.timeMoment.clone().add(duration, 'minutes').format('H.mm')}
            { timeSlot.hasResponsible &&
            <span>
              <AppIcon iconName="STAR" containerClass="resp-image" />
            </span>
            }
          </span>
          <span className="time-slot-info">
            { unit &&
            <span className="time-slot-unit">
              <div className="time-slot-unit-name">{unit.name}</div>
              <div className="time-slot-unit-address">{unit.address}, {unit.city}</div>
            </span>
            }
            { timeSlot &&
            <span className="time-slot-resource">
              <span className="time-slot-resource-name">{timeSlot.resourceName}</span><br />
              <span className="time-slot-speciality">{timeSlot.resourceType}</span>
            </span>
            }
          </span>
        </span>
        <span className="time-slot-card-right">
          {actionElement}
        </span>
      </span>
    </Button>
  );
};

TimeSlotCard.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  large: PropTypes.bool,
  timeSlot: PropTypes.shape({
    timeMoment: PropTypes.instanceOf(moment).isRequired,
    unitName: PropTypes.string,
    resourceName: PropTypes.string.isRequired,
    resourceType: PropTypes.string,
    hasResponsible: PropTypes.bool,
    reservation: PropTypes.string
  }).isRequired,
  unit: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    info: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func,
  actionElement: PropTypes.element.isRequired
};

TimeSlotCard.defaultProps = {
  active: false,
  disabled: false,
  large: false,
  onClick: () => {}
};

export default TimeSlotCard;



// WEBPACK FOOTER //
// ./src/components/TimeSlotCard/index.jsx